import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./ProfileThatGetsBookings.css";
import GetsBooking from "../../Components/HeroSection/assets/GetsBooking.png";
import { Link } from "react-router-dom";

const ProfileThatGetsBookings = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        {/* Blog Heading */}
        <div className="static-header">
          <h1 className="container">How to Build a Profile That Gets Bookings</h1>
        </div>

        {/* Blog Content */}
        <div className="container mt-4 blog-detail-wrapper">
          <img
            src={GetsBooking}
            alt="How to Build a Profile That Gets Bookings"
            className="blog-detail-image"
          />

          <p className="blog-meta">
            <strong>Meta Title:</strong> How to Build a Profile That Gets Bookings on UpskillMeet
            <br />
            <strong>Meta Description:</strong> Learn how to optimize your UpskillMeet profile to attract more explorers, get discovered easily, and increase your chances of session bookings.
          </p>

          <div className="blog-detail-content">
            <p>
              Your profile is your storefront on UpskillMeet. When someone visits it, they’re trying to decide if you’re the right person to book a session with. 
              A well-built profile gives them confidence. A vague or empty one sends them away. This guide shows you exactly what to focus on to get more bookings.
            </p>

            <h2>1. Complete the Info Tab</h2>
            <p>This is the first thing people see. It's your quick pitch.</p>
            <ul>
              <li>Who you are and what you do</li>
              <li>The kind of help you offer</li>
              <li>What makes you different</li>
            </ul>
            <p>
              Write it like you’re introducing yourself to a client or student. Be warm, confident, and clear. Avoid buzzwords and generic phrases. Keep it human.
            </p>

            <h2>2. Add Relevant Work and Education</h2>
            <p>
              You don’t need a full resume—but you do need proof. Highlight roles, internships, or academic background that connect to the services you offer. 
              Even two solid entries make a big difference in building trust.
            </p>

            <h2>3. Choose the Right SME Topics</h2>
            <p>
              Your Subject Matter Expertise (SME) list determines how you show up in search. 
              Only include topics where you can genuinely deliver value. Adding unrelated or weak skills lowers your credibility.
            </p>
            <p>
              Update your SME as you grow. But don’t try to cover everything. Focus wins.
            </p>

            <h2>4. Upload a Real Profile Photo</h2>
            <p>
              A clear, friendly face builds trust. Don’t overthink it. Just make sure the lighting is good and the photo looks like you. 
              No logos, avatars, or blurry selfies.
            </p>

            <h2>5. Enable Services in the MySpace &gt; Services Tab</h2>
            <p>If you want to offer sessions, you need to:</p>
            <ul>
              <li>Subscribe to a Premium Plan</li>
              <li>Go to MySpace &gt; Services</li>
              <li>Turn on "Services Offered"</li>
              <li>Add Upskilling or Business Consulting sessions</li>
            </ul>
            <p>List your pricing clearly. Be transparent.</p>

            <h2>6. Use the Post Section for Visibility</h2>
            <p>
              Good posts help people find you—and trust you. Share useful tips, snapshots from sessions, quick lessons, or project highlights. 
              Avoid spam. Keep it real.
            </p>
            <p>Need ideas? Read <em>What to Post on UpskillMeet</em></p>

            <h2>7. Keep Your Calendar Updated</h2>
            <p>This avoids missed queries or booking clashes. Visit MySpace &gt; Calendar and:</p>
            <ul>
              <li>Block time when you’re not available</li>
              <li>Open slots when you’re ready for sessions</li>
              <li>Offer the right mix (single, weekly, monthly)</li>
            </ul>

            <h2>8. Encourage Testimonials</h2>
            <p>
              After sessions, remind your explorers to leave feedback. 
              The testimonial section on your profile builds social proof. It helps others trust you faster.
            </p>

            <h2>Final Thought</h2>
            <p>
              Think of your profile like a shop window. It needs to be clear, clean, and trustworthy.
              The more effort you put into building it, the easier it becomes to attract bookings. Start refining your profile now.
            </p>

            <h2>Related Reads:</h2>
            <ul className="related-reads">
            <li>
              <Link to="/blog/mistakes-experts-make">
                Top Mistakes Experts Make on UpskillMeet and How to Avoid Them
              </Link>
            </li>
            <li>
              <Link to="/blog/irresistible-profile">
                How to Create an Irresistible Profile on UpskillMeet
              </Link>
            </li>
            <li>
              <Link to="/blog/learner-to-mentor">
                From Learner to Mentor: How UpskillMeet Lets You Do Both
              </Link>
            </li>
          </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfileThatGetsBookings;
